/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react'

import { DataTableList } from '../../components/DataTable/DataTableList';
import TopBar from '../../components/TopBar'
import AddTeamMember from './AddTeamMember';
import DeleteConfirmationPopup from '../../components/DeleteConfirmationPopup';
import UploadMediaPopup from '../../components/UploadMediaPopup';
import { getAllRoles } from '../../api/team';

import Delete from "../../assets/images/delete.svg";
import penIcon from "../../assets/images/pen-img.svg";
import searchIcon from "../../assets/images/icon-search.svg";
import down from "../../assets/images/down.svg";

import styles from './team.module.css'
import { useNavigate } from 'react-router-dom';
import { adminCreate, adminDelete, adminGetAll, adminUpdate } from '../../api/adminUser';

const TeamList = () => {

    const navigate = useNavigate()

    const popupRef = useRef();
    const deletePopupRef = useRef()

    const [userList, setUserList] = useState([])
    const [isLoadingData, setIsLoadingData] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [isAllSelected, setIsAllSelected] = useState(false);
    const [columnWidths, setColumnWidths] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState(1);
    const [toggleSelect, setToggleSelect] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [isNewTeamMember, setIsNewTeamMember] = useState(false);
    const [currentTeamMember, setCurrentTeamMember] = useState(null);
    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const [deleteTarget, setDeleteTarget] = useState(null);

    const [searchInput, setSearchInput] = useState('');

    // Role filter states
    const [selectedRoles, setSelectedRoles] = useState([]);
    const [isRoleDropdownOpen, setIsRoleDropdownOpen] = useState(false);
    const [showUploadMediaPopup, setShowUploadMediaPopup] = useState(false);
    const [uploadMediaPopupFor, setUploadMediaPopupFor] = useState('');
    const [uploadMediaPopupTab, setUploadMediaPopupTab] = useState('upload');
    const [selectedFeatureImage, setSelectedFeatureImage] = useState('');
    const roleDropdownRef = useRef();

    const [formData, setFormData] = useState({
        mediaId: "",
        name: "",
        email: "",
        password: "",
        role: "",
        mobileNumber: "",
        meida: '',
    });
    const [roles, setRoles] = useState([]);
    const [errorMessage, setErrorMessage] = useState({
        mediaId: "",
        name: "",
        email: "",
        password: "",
        role: "",
        mobileNumber: ""
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        setErrorMessage({ ...errorMessage, [e.target.name]: '' });
    };

    const openAddPopup = () => {
        setCurrentTeamMember(null);
        setFormData({
            mediaId: "",
            name: "",
            email: "",
            password: "",
            role: "",
            mobileNumber: "",
            media: '',
        });
        setIsNewTeamMember(true);
        setErrorMessage({
            mediaId: "",
            name: "",
            email: "",
            password: "",
            role: "",
            mobileNumber: ""
        })
    };

    const openRolePage = () => {
        navigate('/team/new-role')
    }

    const openEditPopup = (row) => {
        setCurrentTeamMember(row);
        setFormData(row);
        setIsNewTeamMember(true);
        setErrorMessage({
            mediaId: "",
            name: "",
            email: "",
            role: "",
            mobileNumber: ""
        })
    };

    useEffect(() => {
        if (selectedFeatureImage) {
            setFormData({
                ...formData,
                mediaId: selectedFeatureImage[0]
            });
            setErrorMessage({
                ...errorMessage,
                mediaId: ''
            })
        }
    }, [selectedFeatureImage]);

    const validateForm = () => {
        let errors = {};

        if (!formData.name?.trim()) {
            errors.name = "Name is required";
        }
        if (!formData.email?.trim()) {
            errors.email = "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            errors.email = "Invalid email format";
        }

        if (!formData.role?.trim()) {
            errors.role = "Role is required";
        }

        if (!formData.password?.trim() && (!formData?.adminUserId || formData?.adminUserId === undefined || formData?.adminUserId === '')) {
            errors.password = "Password is required";
        }

        if (!formData.mobileNumber?.trim()) {
            errors.mobileNumber = "Mobile number is required";
        } else if (!/^\+?[\d\s\-\(\)]{10,}$/.test(formData.mobileNumber)) {
            errors.mobileNumber = "Invalid mobile number format";
        }

        if (formData?.mediaId === '' || formData?.mediaId <= 0 || !formData?.mediaId) {
            errors.mediaId = "Image is required";
        }

        setErrorMessage(errors);
        return Object.keys(errors).length === 0;
    };

    const handleSubmit = async () => {
        if (!validateForm()) {
            return;
        }

        const { media, ...restFormData } = formData;

        const dataToSend = { ...restFormData, mediaId: restFormData?.mediaId?.id };

        setIsLoading(true)
        try {
            if (currentTeamMember) {
                const updatedTeam = await adminUpdate(currentTeamMember?.adminUserId, dataToSend);
                if (updatedTeam?.success) {
                    await fetchUsers()
                }
            } else {
                const newTeam = await adminCreate(dataToSend);
                if (newTeam?.success) {
                    await fetchUsers()
                }
            }
            setIsNewTeamMember(false);
        } catch (error) {
            if(error?.response?.data?.error.message === 'Email already exists. Please try another email') {
                setErrorMessage({...errorMessage, email: error?.response?.data?.error.message})
            } else if(error?.response?.data?.error.message === 'Mobile number already exists. Please try another mobile number'){
                setErrorMessage({...errorMessage, mobileNumber: error?.response?.data?.error.message})
            }
        }
        setIsLoading(false)
    };

    const calculateColumnWidths = async () => {
        return new Promise((resolve) => {
            const tempWidths = userList?.reduce((acc, row) => {
                Object.keys(row).forEach((key) => {
                    let dataValue;
                    let title;

                    if (key === 'name') {
                        dataValue = row.name;
                        title = 'Name';
                    } else {
                        dataValue = row[key]?.toString();
                        title = key;
                    }

                    let maxContentLength = Math.max(dataValue?.length, title?.length);

                    if (!acc[key] || maxContentLength > acc[key]) {
                        acc[key] = maxContentLength;
                    }
                });
                return acc;
            }, {});

            if (tempWidths !== undefined) {
                const widthMap = Object.keys(tempWidths).reduce((acc, key) => {
                    acc[key] = `${tempWidths[key] * 10 + 40}px`;
                    return acc;
                }, {});
                setColumnWidths(widthMap);
            }
            resolve();
        });
    };

    useEffect(() => {
        if (userList?.length > 0) {
            calculateColumnWidths();
        }
    }, [userList]);

    useEffect(() => {
        fetchRoles();
    }, [])

    useEffect(() => {
        if (Object.keys(columnWidths).length > 0) {
            setTimeout(() => {
                setIsLoadingData(false);
            }, 1000);
        }
    }, [columnWidths]);

    useEffect(() => {
        fetchUsers();
    }, [selectedRoles, currentPage]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (deletePopupRef.current && !deletePopupRef.current.contains(event.target)) {
                setShowDeletePopup(false);
            }
            if (popupRef.current && !popupRef.current.contains(event.target) && !showUploadMediaPopup) {
                setIsNewTeamMember(false);
            }
            if (roleDropdownRef.current && !roleDropdownRef.current.contains(event.target)) {
                setIsRoleDropdownOpen(false);
            }
        };

        // Attach the event listener when the component mounts
        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showUploadMediaPopup]);

    const handleMasterCheckboxChange = () => {
        if (isAllSelected) {
            setSelectedRows([]);
        } else {
            setSelectedRows(userList?.map((row) => row?.adminUserId));
        }
        setIsAllSelected(!isAllSelected);
    };

    const columns = [
        {
            name: 'Email',
            selector: (row) => row?.email,
            cell: (row) => <div className='team-list-name-row'><div><img src={row?.media?.url} alt={row.email} /></div><div>{row?.email}</div></div>,
            sortable: true,
            minWidth: columnWidths['email'] && (parseInt(columnWidths['email']) + 50 > 300) ? '300px' : `${parseInt(columnWidths['email']) + 50}px`,
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px", fontSize: "14px" },

        },
        {
            name: 'Name',
            selector: (row) => row?.name,
            cell: (row) => <div>{row.name}</div>,
            sortable: true,
            width: columnWidths['name'] && `${parseInt(columnWidths['name']) - 20}px`,
            style: { width: columnWidths['name'] || '250px', paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px", fontSize: "14px" },
        },
        {
            name: 'Role',
            selector: row => row.role,
            cell: (row) => {
                const roleClass = `role${row.role.charAt(0).toUpperCase() + row.role.slice(1).toLowerCase()}`;
                return (
                    <div className={`${styles.userRole} ${styles[roleClass]}`}>
                        {row.role}
                    </div>
                );
            },
            sortable: true,
            width: columnWidths['role'] && `${parseInt(columnWidths['role']) - 20}px`,
            style: { width: columnWidths['role'] || '150px', paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px", fontSize: "14px" },
        },
        {
            name: "Actions",
            cell: (row) => (
                <div className="action-buttons">
                    <button className="edit-btn" onClick={() => openEditPopup(row)}><img src={penIcon} alt="pen-icon" /></button>
                    <button className="delete-btn" onClick={() => {
                        setDeleteTarget({ type: "single", row });
                        setShowDeletePopup(true);
                    }}><img src={Delete} alt="delete-icon" /></button>
                </div>
            ),
            width: "90px"
        }
    ];

    const customStyles = {
        headCells: {
            style: {
                fontWeight: 500,
                fontSize: '14px',
            },
        },
    };

    const handleImageUpload = (e) => {
        e.stopPropagation();
        setShowUploadMediaPopup(true); setUploadMediaPopupFor('feature-image'); setUploadMediaPopupTab('media');
    };

    const confirmDelete = async () => {
        if (!deleteTarget) return;
        setIsLoading(true)
        try {
            if (deleteTarget.type === "single") {
                await adminDelete([deleteTarget?.row?.adminUserId]);
            }

            if (deleteTarget.type === "multiple") {
                await adminDelete(deleteTarget?.rows);
                setSelectedRows([]);
                setIsAllSelected(false);
                setToggleSelect(prev => !prev);
            }
            await fetchUsers()
        } catch (error) {
            console.error('Failed to delete team:', error);
        }
        setIsLoading(false)

        setShowDeletePopup(false);
        setDeleteTarget(null);
    };

    const handleRoleSelect = (role) => {

        setSelectedRoles(prev => {
            if (prev.includes(role)) {
                return prev.filter(r => r?.roleId !== role?.roleId);
            } else {
                return [...prev, role];
            }
        });
    };

    const fetchRoles = async () => {
        try {
            const response = await getAllRoles();
            setRoles(response?.data);
        } catch (error) {
            console.error('Failed to fetch roles:', error);
        }
    };

    const fetchUsers = async () => {
        setIsLoadingData(true);
        try {

            const response = await adminGetAll({
                page: currentPage,
                search: searchInput,
                role: selectedRoles?.map((item) => item?.role).join(',') || "",
                sortBy: 'createdAt',
            });
            if(response?.data?.users <= 0){
                setIsLoadingData(false)
            }
            setTotalPage(response?.data?.pagination?.totalPages || 1)
            setUserList(response?.data?.users || []);
        } catch (error) {
            console.error('Failed to fetch users:', error);
            setUserList([]);
            setIsLoadingData(false)
        }
    };

    const handleSearch = async () => {
        await fetchUsers()
    }

    return (
        <div className={`${styles.teamPageHeight} ${userList?.length <= 10 && styles.teamPageHeight}`}>
            <TopBar />
            <div className={styles.teamDatatableList}>
                <div className={styles.teamHeader}>
                    <div className={styles.leftSide}>
                        <div className={styles.searchBar}>
                            <img src={searchIcon} alt="Search" />
                            <input
                                type="text"
                                placeholder="Search team members..."
                                value={searchInput}
                                onChange={(e) => setSearchInput(e.target.value)}
                                onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
                            />
                        </div>
                        <button className={styles.addBtn} onClick={() => handleSearch()}>Search</button>

                        {/* Role Filter Dropdown */}
                    </div>
                    <div className={styles.actionButtonsDeleteAdd}>
                        <div className="dropdown-wrapper" ref={roleDropdownRef}>
                            <div className="dropdown-header" onClick={() => setIsRoleDropdownOpen(!isRoleDropdownOpen)}>
                                <span className="title">
                                    Select Role {selectedRoles?.length > 0 && `(${selectedRoles?.length})`}
                                </span>
                                <span className={`arrow ${isRoleDropdownOpen ? "rotate" : ""}`}>
                                    <img src={down} alt="down" />
                                </span>
                            </div>

                            {isRoleDropdownOpen && (
                                <div className="dropdown-list">
                                    {roles?.map((item, index) => (
                                        <label key={index} className="dropdown-item">
                                            <input
                                                type="checkbox"
                                                checked={selectedRoles?.includes(item)}
                                                onChange={() => handleRoleSelect(item)}
                                            />
                                            <span>{item?.role}</span>
                                        </label>
                                    ))}
                                </div>
                            )}
                        </div>

                        <button className={styles.addBtn} onClick={openAddPopup}>Add Team</button>
                        <button className={styles.addBtn} onClick={openRolePage}>Add Role</button>
                        {selectedRows?.length > 0 && (
                            <div onClick={() => {
                                setDeleteTarget({ type: "multiple", rows: selectedRows });
                                setShowDeletePopup(true);
                            }}>
                                <img src={Delete} alt="delete-icon" />
                            </div>
                        )}
                    </div>
                </div>

                <div className={`pagesTable dataTable-list ${userList?.length <= 10 && 'dataTable-border-list'} ${(isLoadingData) ? 'loading-list' : ''} `}>
                    <DataTableList
                        columns={columns}
                        data={userList}
                        onSelectedRowsChange={({ selectedRows }) => {
                            const selectedIds = selectedRows.map((row) => row?.adminUserId);
                            setSelectedRows(selectedIds);
                            setIsAllSelected(selectedIds.length === userList.length);
                        }}
                        progressPending={isLoadingData}
                        currentPage={currentPage}
                        onChangePage={setCurrentPage}
                        paginationTotalRows={totalPage}
                        selectableRows
                        selectAllRows={isAllSelected}
                        clearSelectedRows={toggleSelect}
                        onSelectAllChange={handleMasterCheckboxChange}
                        customStyles={customStyles}
                        selectableRowsComponent="input"
                        progressComponent={<div className="loader-container"> <div className="loader"></div> </div>}
                    />
                </div>
            </div>

            <AddTeamMember
                isNewTeamMember={isNewTeamMember}
                formData={formData}
                handleSubmit={handleSubmit}
                setIsNewTeamMember={setIsNewTeamMember}
                currentTeamMember={currentTeamMember}
                handleChange={handleChange}
                refrence={popupRef}
                errorMessage={errorMessage}
                handleImageUpload={handleImageUpload}
                roles={roles}
                isLoading={isLoading}
            />

            <DeleteConfirmationPopup
                showDeletePopup={showDeletePopup}
                setShowDeletePopup={setShowDeletePopup}
                reference={deletePopupRef}
                title={deleteTarget?.type === "single" ? 'team member' : selectedRows?.length === 1 ? 'team member' : `team members`}
                description={deleteTarget?.type === "single" ? `Are you sure you want to delete ${deleteTarget?.row?.name}?` : selectedRows?.length === 1 ? `Are you sure you want to delete team member?` : `Are you sure you want to delete ${selectedRows?.length} team members?`}
                confirmDelete={confirmDelete}
                isLoading={isLoading}
            />
            {showUploadMediaPopup &&
                <UploadMediaPopup showUploadMediaPopup={showUploadMediaPopup} setShowUploadMediaPopup={setShowUploadMediaPopup} setSelectedProfileImage={setSelectedFeatureImage} uploadMediaPopupFor={uploadMediaPopupFor} uploadMediaPopupTab={uploadMediaPopupTab} />
            }
        </div>
    )
}

export default TeamList